// extracted by mini-css-extract-plugin
export default {"description":"BarStatistics_description__C8fuw"};